module.exports = __webpack_public_path__ + "static/media/head_default_img.8961a512.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/head_default_img.png
// module id = 95
// module chunks = 2